<div class="sdl-container">
    <div class="sdl-image-section">
        <img *ngIf="imageUrl && !imageError; else imageFallback" [src]="imageUrl" alt="" (error)="onImageError()">
        <ng-template #imageFallback>
            <div class="image-fallback">
                <img src="../../../../assets/icons/error.svg" alt="" aria-hidden="true">
            </div>
        </ng-template>
        <div class="lesson-badge">
            <img src="../../../../assets/icons/stairs-emphasis.svg" alt="" aria-hidden="true" style="width: 16px; height: 16px;">
            <span class="visually-hidden">{{ 'learningLibrary.lessonCard.difficulty_level' | translate }} {{
                difficultyLevel }}</span>
            <span aria-hidden="true">{{ difficultyLevel }}</span>
        </div>
    </div>
    <div class="sdl-description">
        <div class="sdl-title-desc">
            <h2 class="c11n-text-md-bold title">
                {{ quizTitle }}
            </h2>
            <div class="c11n-text-sm desc">
                {{ cleanDescription }}
            </div>
        </div>
    </div>
    <div class="btn-section">
        <div class="sdl-btn-section">
            <c11n-button [buttonType]="'submit'" [size]="'small'"
                [labelText]="'learningLibrary.lessonCard.startLesson' | translate" [variant]="'secondary'"
                [ariaLabelText]="(quizTitle ? quizTitle + ' ' : '') + ('learningLibrary.lessonCard.startLesson' | translate)"
                (clickEvent)="onViewLesson()">
            </c11n-button>
        </div>
    </div>
</div>